const env = import.meta.env

export const ENV = {
  // Same-origin by default: /api rides the Vite proxy (see vite.config.ts) so
  // the backend's HttpOnly bs_auth session cookie flows without CORS.
  API_BASE_URL: env.VITE_API_BASE_URL || '/api',
  NODE_ENV: env.MODE,

  // Mock mode: the conversation flow plays entirely from the bundled .data.ts
  // catalogs (designer showcase). Off by default — the real backend drives.
  USE_MOCKS: env.VITE_USE_MOCKS === 'true',

  // ----------------- Site Config -----------------
  SITE_BASE_URL: env.VITE_SITE_BASE_URL ?? false,

  // ----------------- Robots.txt Configuration -----------------
  ALLOW_ROBOTS: env.VITE_ALLOW_ROBOTS ?? false,

  // ------------------ GOOGLE MAP ------------------
  GOOGLE_MAP_KEY: env.VITE_GOOGLE_MAP_KEY || '',
  GOOGLE_MAP_ID: env.VITE_GOOGLE_MAP_ID || '',
  GOOGLE_TAG_MANAGER_ID: env.VITE_GOOGLE_TAG_MANAGER_ID || '',

  // ------------------ GOOGLE OAUTH ------------------
  GOOGLE_OAUTH_CLIENT_ID: env.VITE_GOOGLE_OAUTH_CLIENT_ID || '',

  // ------------------ GOOGLE RECAPTCHA ------------------
  GOOGLE_RECAPTCHA_SITE_KEY: env.VITE_GOOGLE_RECAPTCHA_SITE_KEY || '',

  // ----------------- Intercom Chatbot -----------------
  INTERCOM_APP_ID: env.VITE_INTERCOM_APP_ID || '',

  // ------------------ APP URL ------------------
  APP_URL: env.VITE_APP_URL || 'http://localhost:3000',
}

export const isDevelopmentMode = env.MODE === 'development'
export const isProductionMode = env.MODE === 'production'
